<template>
  <div class="regist">
    <div class="re_header">
      <ul>
        <li><i class="cls-or left-row"></i>填写账户信息<i class="el-icon-arrow-right"></i></li>
        <li><i class="cls-or left-row"></i>邮箱验证<i class="el-icon-arrow-right"></i></li>
        <li class="active" v-if="isActive"><i class="el-icon-circle-check left-row"></i>设置新密码</li>
        <li class="active" v-else><i class="el-icon-circle-close left-row"></i>验证失败</li>
        <li><i class="cls-or left-row"></i>修改完成</li>
      </ul>
    </div>
    <hr>
    <div class="message">
      <h2>找回密码</h2>
      <div class="sc-sendsed" v-if="isActive">
        <el-form :model="userItem" ref="ruleForm" :rules="userRule" label-width="100px" class="userForm">
          <el-form-item label="新密码" prop="password">
            <el-input type="password" v-model="userItem.password" placeholder="请输入密码" show-password clearable></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="password2">
            <el-input type="password" v-model="userItem.password2" placeholder="请输入确认密码" show-password clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="btn-reg" @click="submitForm()">重置密码</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="sc-sendsed" v-else>
        {{content}}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'saccountpwd',
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.userItem.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      isActive: false,
      content: '稍等: 账号激活中。。。',
      checked: true,
      userItem: {
        sign: this.$route.query.sign,
        password: ''
      },
      userRule: {
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { pattern: /^(?![0-9A-Z]+$)(?![0-9a-z]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/, message: '必须包含数字、大小写字母，且至少六位' }
        ],
        password2: [
          { required: true, validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    // 调用激活邮箱接口
    // 得到邮件标记
    let sign = { sign: this.$route.query.sign }
    this.sapost('/dmc/account/checkSendEmail', sign, r => {
      let { retCode, retMsg } = r.data
      if (retCode === '0') {
        this.isActive = true
      } else {
        this.$message.warning(retMsg)
        this.content = retMsg
      }
    })
  },
  methods: {
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.sapost('/dmc/account/changePassword', this.userItem, r => {
            let { retMsg, retCode } = r.data
            if (retCode === '0') {
              console.log(retMsg)
              this.$router.push({
                path: '/resetSuccesspwd'
              })
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="less">
.regist {
  width: 1100px;
  margin: 10px auto;
  min-height: 650px;
  .re_header {
    overflow: hidden;
    line-height: 55px;
    height: 55px;
    margin: 35px 0px;
    background-color: #f5f7fa;
    ul {
      overflow: hidden;
      li {
        float: left;
        width: 195px;
        padding-left: 80px;
        color: #c1c5cd;
        .cls-or {
          display: inline-block;
          height: 12px;
          width: 12px;
          border-radius: 50%;
          box-shadow: 0 0 0 1px #c0c4cc;
        }
        .left-row {
          margin-right: 10px;
        }
        .el-icon-arrow-right {
          float: right;
          line-height: 55px;
        }
      }
      .active {
        color: rgb(28, 203, 150);
        font-weight: 600;
      }
    }
  }
  hr {
    background-color: #f5f7fa;
    height: 2px;
    border: 0;
    margin-bottom: 30px;
  }
  .message {
    border: 3px solid #f5f7fa;
    border-radius: 5px;
    color: #818180;
    text-align: left;
    h2 {
      padding-left: 25px;
      height: 45px;
      line-height: 45px;
      background-color: #f5f7fa;
    }
    .sc-sendsed {
      color: rgb(28, 203, 150);
      text-align: center;
      font-size: 20px;
      font-weight: 500;
      padding: 35px 0;
      margin: 0 15px;
    }
  }
  .userForm {
    width: 500px;
    margin: 10px auto;
    height: 50%;
    .btn-reg {
      width: 40%;
      border: none;
      background-color: rgb(28, 203, 150);
    }
    .btn-reg:hover {
      background-color: rgb(28, 203, 150);
    }
    .btn-reg:focus {
      background-color: rgb(28, 203, 150);
    }
    .checkcode {
      margin-left: 15px;
      font-size: 12px;
      color: #6da2d3;
    }
    .el-form-item__content {
      text-align: left;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/SaccountPwd.vue